















import { Component, Vue } from 'vue-property-decorator';
import AlbumCard from '@/components/Album/AlbumCard.vue';
import SimpleAlbum from '@/types/SimpleAlbum';

import albums from '@/data/albums.json';

@Component({
  components: { AlbumCard },
})
export default class Bibliography extends Vue {
  private albums!: Array<SimpleAlbum>;

  created() {
    this.albums = albums;
  }
}
